import GameIcon from './GameIcon';
import { getDefaultPlayableIcon } from './gameCatalog';

function GameLibrary({
  games,
  onSelectGame,
  onSelectPlayerIcon,
  selectedPlayerIcons = {},
}) {
  return (
    <main className="game-app library-app">
      <section className="library-shell" aria-labelledby="app-title">
        <header className="library-header">
          <div>
            <h1 id="app-title">Arcade Library</h1>
          </div>
          <span className="library-count">{games.length} games</span>
        </header>

        <div className="library-grid" aria-label="Released games">
          {games.map((game) => {
            const isComingSoon = game.status === 'coming-soon';
            const isDevelopment = game.releaseState === 'development';

            return (
              <article
                className={`game-card game-card-${game.accent}${isComingSoon ? ' game-card-coming-soon' : ''}`}
                key={game.id}
              >
                <div className="game-card-marquee" aria-hidden="true">
                  <GameIcon icon={game.icon ?? game.id} />
                </div>
                <div className="game-card-body">
                  <div className="game-card-title-row">
                    <h2>{game.name}</h2>
                    <div className="game-card-badges">
                      {isDevelopment ? <span className="game-card-dev-badge">Dev</span> : null}
                      {isComingSoon ? <span>Coming soon</span> : null}
                    </div>
                  </div>
                  <p>{game.summary}</p>
                  {game.playableIcons?.length ? (
                    <div className="game-card-player-picker" aria-label={`${game.name} playable icons`}>
                      {game.playableIcons.map((playableIcon) => {
                        const selectedIconId = selectedPlayerIcons[game.id] ??
                          getDefaultPlayableIcon(game)?.id;
                        const isSelected = playableIcon.id === selectedIconId;

                        return (
                          <button
                            aria-label={`Select ${game.name} playable icon: ${playableIcon.name}`}
                            aria-pressed={isSelected}
                            className={isSelected ? 'selected' : ''}
                            key={playableIcon.id}
                            onClick={() => onSelectPlayerIcon?.(game.id, playableIcon.id)}
                            type="button"
                          >
                            <GameIcon icon={playableIcon.icon} className="game-card-player-icon" />
                            <span>{playableIcon.name}</span>
                          </button>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
                <button
                  type="button"
                  disabled={isComingSoon}
                  onClick={() => onSelectGame(game.id)}
                >
                  {isComingSoon ? 'Coming soon' : `Start ${game.name}`}
                </button>
              </article>
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default GameLibrary;
